<template>
    <VueSelect
        :options="options"
        :placeholder="$t('general.select_default')"
        :value="modelValue"
        @update:modelValue="onSelect"
        :closeOnSelect="true"
        :selectOnBlur="false"
        class="custom-select"
    >
        <template #option="{ option }">
            <div
                class="vs-option w-100"
                @mousedown.prevent
                @click="onSelect(option.value)"
            >
                {{ option.label }}
            </div>
        </template>
    </VueSelect>
</template>

<script setup lang="ts">
import VueSelect, { type Option } from "vue3-select-component";

const {options, modelValue} = defineProps<{
    options: Option<any>[],
    modelValue: any
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: any)
}>()

function onSelect(value: any) {
    emit('update:modelValue', value)
}

</script>

<style lang="scss">
@import "vue3-select-component/styles";
.custom-select{
    --vs-background-color: var(--bs-body-bg);

    & .clear-button,
    & .dropdown-icon{
        display: flex;
        justify-content: center;
    }

    & .dropdown-icon{
        &.active{
            transform: none !important;
        }
    }
}

</style>
